import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import AE2CNavbar from "./components/AE2CNavbar";
import { useAuth } from "./auth";

/* Navbar hrefs are bare slugs ("pos"); turn them into router paths ("/pos"). */
export const RouterLink = ({ href, ...props }) => <Link to={href.startsWith("/") ? href : `/${href}`} {...props} />;

export default function Layout({ username, role }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);

  const { logout } = useAuth();
  const handleLogout = async (e) => {
    e?.preventDefault?.();
    await logout(); // deletes the session row (logout.php); the app then shows the sign-in screen
    navigate("/", { replace: true });
  };

  return (
    <div className="app">
      <AE2CNavbar username={username} isAdmin={role === "admin"} LinkComponent={RouterLink} logoutHref="/signed-out" onLogout={handleLogout} />
      <Outlet />
    </div>
  );
}
